var MultiClamp = require('./MultiClamp');

module.exports = MultiClamp;
